export enum NotificationType {
    Filter = 1,
    Following = 2,
    FollowedUserShare = 3,
    CommentOnDeal = 4,
    ReplyOnComment = 5,
}
export interface Notification {
    notification_id: number;
    notification_user_id: number;
    notification_author_id: number;
    notification_link_id: number;
    notification_filter_id: number;
    notification_type: NotificationType;
    notification_active: number;
}
